import styled from 'styled-components'
import {   Button  } from 'react-bootstrap'



export const LoginSection = styled.div`

    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%); 
    background-color: #f7f7f8;
    border: 1px solid #e5e5e5;

`;

export const FormSection = styled.div`
    background-color: white;
    padding: 20px;
    height: 100%;
    text-align: center;
    h5{
        margin: 20px 0px;
    }
    h6{
        margin-bottom: 20px;
        font-size: 20px;
        font-weight: 700;
    }
`;

export const SocialLogin = styled.div`

display: flex;
justify-content: center;
>div{
    padding: 8px 14px;
    background-color:#eceded;
    margin: 5px 10px;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
}
img{
    width: 20px;
    height: 20px;
    margin-right: 5px;
}
`;

export const FormContainer = styled.div`
    text-align: start;
    margin: 10px 0px;
    p{
        font-size: 12px;
        text-align: center;
        margin-top: 30px;
        color: #696262;
    }
`;
export const FormBtn = styled(Button)`
    display: block;
    width: 100%;
`;
